import axios from 'axios';
import store from '../redux/store/store';
const API_COMPANY_URL = import.meta.env.VITE_API_URL;

const companyService = {
  // adres işlemleri
  updateAddress: (data, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.put(`${API_COMPANY_URL}/CompanyAddress`, data, {
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    });
  },
  getAddress: (companyId, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    const queryParams = new URLSearchParams({ companyId: companyId });
    return axios.get(`${API_COMPANY_URL}/CompanyAddress?${queryParams.toString()}`, {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },


  addAddress: (data, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      return axios.post(`${API_COMPANY_URL}/CompanyAddress`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`
          }
        });
    } catch { }

  },


  addCompany: (data, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    console.group("mağza ekleme işlemi", token)
    return axios.post(`${API_COMPANY_URL}/Company`, data, {
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    });
  },



  getCompany: (id, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.get(`${API_COMPANY_URL}/Company?userId=${id}`, {
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    });
  },

  //MAĞZA GÜCELLE
  companyUpdateApi: (data, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.put(`${API_COMPANY_URL}/Company`, data, {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },


  //adres sil
  addresDeleteApi: (id, token) => {
    const userToken = store.getState()?.auth?.user?.accessToken?.token;
    return axios.delete(`${API_COMPANY_URL}/CompanyAddress`, {
      params: { Id: id },
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
  },
};




export default companyService;
